import React, { useState } from 'react';
import { useI18n } from '../i18n';
import { useNotification } from '../context/NotificationContext';
import { sendContactMessage } from '../api';
import './Contact.css'; // Will create if needed, or inline styles.

function Contact() {
  const { t } = useI18n();
  const { addNotification } = useNotification();

  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [botField, setBotField] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setIsSubmitting(true);
    try {
      await sendContactMessage({ name, message, bot_field: botField });
      addNotification(t('contact.success'), 'success');
      setName('');
      setMessage('');
      setBotField('');
    } catch (err) {
      addNotification(t('contact.error'), 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page container animate-fade-in" style={{ padding: '2rem' }}>
      <h2>{t('contact.title')}</h2>

      <p style={{ whiteSpace: 'pre-line', marginBottom: '2rem' }}>
        {t('contact.description')}
      </p>

      <form onSubmit={handleSubmit} className="contact-form" style={{ display: 'flex', flexDirection: 'column', maxWidth: '500px', gap: '1rem' }}>
        {/* Honeypot field */}
        <input
          type="text"
          value={botField}
          onChange={e => setBotField(e.target.value)}
          style={{ display: 'none' }}
          tabIndex="-1"
          autoComplete="off"
        />

        <div className="form-group">
          <label style={{ display: 'block', marginBottom: '0.5rem' }}>{t('contact.nameInput')}</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t('contact.nameInput')}
            style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border-color)', background: 'var(--bg-secondary)', color: 'var(--text-primary)' }}
          />
        </div>

        <div className="form-group">
          <label style={{ display: 'block', marginBottom: '0.5rem' }}>{t('contact.messageInput')}</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            rows="6"
            placeholder={t('contact.messageInput')}
            style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border-color)', background: 'var(--bg-secondary)', color: 'var(--text-primary)', resize: 'vertical' }}
          />
        </div>

        <button type="submit" disabled={isSubmitting} className="auth-cyber-btn" style={{ padding: '0.75rem 1.5rem', alignSelf: 'flex-start', cursor: isSubmitting ? 'not-allowed' : 'pointer', opacity: isSubmitting ? 0.7 : 1 }}>
          {t('contact.submit')}
        </button>
      </form>
    </div>
  );
}

export default Contact;
